// project imports

// assets
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { reliefApi } from 'services/api';
import { ReliefStatus } from 'config';
import UIManager from 'core/UIManager';
import ModalCustom from 'components/Modal/ModalCustom';

// project imports

// ===========================|| FIREBASE - REGISTER ||=========================== //
interface IProps {
    onClose: () => void;
    reliefId: string;
    callback: () => void;
}

const AskClusterModal = (props: IProps) => {
    const { onClose, reliefId, callback } = props;
    const navigate = useNavigate();

    const handleConfirmAskCM = async () => {
        try {
            const res = await reliefApi.UpdateReliefById(reliefId, ReliefStatus.PENDING_STAFF_ASSIGNATION);
            if (!res.error) {
                UIManager.showAlert({
                    message: 'Ask Cluster Manager successfully',
                    alert: {
                        color: 'success'
                    }
                });
                onClose();
                if (callback) callback();
                navigate('/staff/relief-list', { replace: true });
            } else {
                UIManager.showAlert({
                    message: res?.error?.response?.data?.message,
                    alert: {
                        color: 'error'
                    }
                });
                onClose();
            }
        } catch (error) {
            UIManager.showAlert({
                message: 'Something went wrong',
                alert: {
                    color: 'error'
                }
            });
        }
    };

    return (
        <ModalCustom
            onSave={handleConfirmAskCM}
            onCancel={() => {}}
            onClose={onClose}
            title="Send Relief Ticket to Cluster Manager"
            contentSave="OK"
        >
            <Grid item xs={12} style={{ padding: '20px 10px', textAlign: 'center' }}>
                <Typography gutterBottom component="div">
                    The relief ticket information will be sent to the Cluster Manager for further assistance.
                </Typography>
            </Grid>
        </ModalCustom>
    );
};

export default AskClusterModal;
